import { inject, Injectable } from '@angular/core';
import { GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY } from '../../../../../graphql.module';
import { QuoteRequestFilterInput, QuoteRequestSortInput } from '../../../../../../graphql';
import { GetQuoteRequestsV2 } from '../queries/GetQuoteRequestsV2.generated';
import { Apollo } from 'apollo-angular';

@Injectable({
    providedIn: 'root',
})
export class QuoteRequestListApiService {
    #apollo = inject(Apollo);

    private get gql() {
        return this.#apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY);
    }

    getQuoteRequests(
        take: number,
        skip: number,
        search?: string | null | undefined,
        status?: string | null | undefined,
        order?: [QuoteRequestSortInput] | null | undefined,
        where?: QuoteRequestFilterInput | null | undefined
    ) {
        return this.gql.query({
            query: GetQuoteRequestsV2,
            variables: {
                take,
                skip,
                search,
                status,
                order,
                where,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }
}
